"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.SelectedPhoneVerificationMethod=void 0;var t;(function(e){e.Sms="sms",e.Whatsapp="whatsapp"})(t||(exports.SelectedPhoneVerificationMethod=t={}));
//# sourceMappingURL=SelectedPhoneVerificationMethod.js.map
